import React from "react"
import Card from "../../../containers/Card/Card"
import DepositProductField from "./DepositProductField/DepositProductField"
import {DepositProductCashbackProps} from "./types"
import {EditMode} from "../../../resources/common"
import classNames from "classnames"
import {CashbackRateType} from "../../../resources/depositProduct"
import {toInteger} from "lodash"
import {
	CASHBACK_MVP_MONTHLY_CAP_CENTS,
	CASHBACK_MVP_RATE_BPS,
	bpsToCashbackRatePercent,
	cashbackRatePercentToBps,
} from "../cashbackUtils"

export default function Cashback({editMode, values, setFieldValue, onBlur}: DepositProductCashbackProps) {
	const rateType: CashbackRateType = values.cashbackRateType ?? "Percentage"
	const isPercentage = rateType === "Percentage"
	const cashbackEnabled = values.cashbackEnabled ?? false
	const cashbackRatePercent =
		values.cashbackRate !== undefined
			? bpsToCashbackRatePercent(values.cashbackRate)
			: bpsToCashbackRatePercent(CASHBACK_MVP_RATE_BPS)

	return (
		<Card
			className="deposit-product-card-title"
			title={
				<span className="card-title" id="Cashback">
					Cashback
				</span>
			}
		>
			<div className={classNames("form-row four checkbox", editMode === EditMode.VIEW && "view")}>
				<DepositProductField
					mode={editMode}
					type="checkbox"
					inputType="input"
					name="cashbackEnabled"
					label="Cashback"
					checked={cashbackEnabled}
					value={cashbackEnabled}
					onChange={() => setFieldValue("cashbackEnabled", !cashbackEnabled)}
					onBlur={onBlur}
				/>
			</div>
			{cashbackEnabled && (
				<div className={classNames("form-row four", editMode === EditMode.VIEW && "view")}>
					<DepositProductField
						mode={editMode}
						type="select"
						name="cashbackRateType"
						label="Rate Type"
						value={rateType}
						disabled
						onChange={(e) => setFieldValue("cashbackRateType", e.target.value)}
						onBlur={onBlur}
					>
						<option value="Percentage">Percentage</option>
						<option value="Fixed">Fixed Amount</option>
					</DepositProductField>
					{isPercentage ? (
						<DepositProductField
							mode={editMode}
							type="input"
							name="cashbackRate"
							label="Rate"
							value={cashbackRatePercent}
							inputSuffix="%"
							disabled
							min={0}
							max={100}
							onChange={(value) =>
								setFieldValue("cashbackRate", value === "" ? undefined : cashbackRatePercentToBps(Number(value)))
							}
							onBlur={onBlur}
							inputType="number"
						/>
					) : (
						<DepositProductField
							mode={editMode}
							type="input"
							name="cashbackFixedAmountCents"
							label="Fixed Amount"
							value={values.cashbackFixedAmountCents !== undefined ? values.cashbackFixedAmountCents / 100 : ""}
							inputFormat="0,0.00"
							inputPrefix={"$"}
							disabled
							onChange={(value) =>
								setFieldValue(
									"cashbackFixedAmountCents",
									value == null || value === "" ? undefined : Number(value) * 100
								)
							}
							onBlur={onBlur}
							inputType="number"
						/>
					)}
					<DepositProductField
						mode={editMode}
						type="input"
						name="cashbackMonthlyCapCents"
						label="Monthly Cap"
						value={
							values.cashbackMonthlyCapCents !== undefined
								? values.cashbackMonthlyCapCents / 100
								: CASHBACK_MVP_MONTHLY_CAP_CENTS / 100
						}
						inputFormat="0,0.00"
						inputPrefix={"$"}
						disabled
						onChange={(value) =>
							setFieldValue("cashbackMonthlyCapCents", value == null || value === "" ? undefined : Number(value) * 100)
						}
						onBlur={onBlur}
						inputType="number"
					/>
					<DepositProductField
						mode={editMode}
						type="input"
						name="cashbackMinMonthlySpendCents"
						label="Min. Monthly Spend"
						subLabel="optional"
						value={values.cashbackMinMonthlySpendCents != null ? values.cashbackMinMonthlySpendCents / 100 : ""}
						inputFormat="0,0.00"
						inputPrefix={"$"}
						onChange={(value) =>
							setFieldValue("cashbackMinMonthlySpendCents", value == null || value === "" ? null : Number(value) * 100)
						}
						onBlur={onBlur}
						inputType="number"
					/>
					<DepositProductField
						mode={editMode}
						type="input"
						name="cashbackFundingAccountId"
						label="Funding Account ID"
						value={values.cashbackFundingAccountId ?? ""}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							setFieldValue("cashbackFundingAccountId", e.target.value)
						}
						onBlur={onBlur}
					/>
					<DepositProductField
						mode={editMode}
						type="input"
						name="cashbackUnitShare"
						label="Unit Share"
						value={values.cashbackUnitShare ?? ""}
						inputSuffix="%"
						min={0}
						max={100}
						onChange={(value) => setFieldValue("cashbackUnitShare", value === "" ? undefined : toInteger(value))}
						onBlur={onBlur}
						inputType="number"
					/>
				</div>
			)}
		</Card>
	)
}
